// extracted by mini-css-extract-plugin
module.exports = {"image":"cD","image-placeholder":"cE","imagePlaceholder":"cE"};